export const toggelModal = (store, show, globalActions) => {
  store.setState({ showModal: show })
}

export const toggelStartWeightModal = (store, show, globalActions) => {
  store.setState({ showStartWeightModal: show })
}
